import React from 'react';
import { number, string } from 'prop-types';

const IconCalendar = ({ width = 22, height = 25, fill = '#ffffff' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 22 25" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 22V4.88889C22 3.54444 20.9 2.44444 19.5556 2.44444H18.3333V0H15.8889V2.44444H6.11111V0H3.66667V2.44444H2.44444C1.08778 2.44444 0.0122222 3.54444 0.0122222 4.88889L0 22C0 23.3444 1.08778 24.4444 2.44444 24.4444H19.5556C20.9 24.4444 22 23.3444 22 22ZM7.33321 11H4.88877V13.4444H7.33321V11ZM2.44438 7.33321H19.5555V4.88877H2.44438V7.33321ZM19.5555 9.77754V21.9998H2.44438V9.77754H19.5555ZM14.6666 13.4444H17.111V11H14.6666V13.4444ZM12.2223 13.4444H9.77781V11H12.2223V13.4444Z" 
        fill={fill}
      />
    </svg>
  );
};

IconCalendar.propTypes = {
  width: number,
  height: number,
  fill: string,
};

export default IconCalendar;
